import { Helmet } from 'react-helmet-async';

export const HelmetAsync = ({ title, description, keywords, body }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <body className={body}/>
    </Helmet>
  );
};